import React, {Component} from 'react';
import BaseLayout from './../../templates/base';
import logo from './../../assets/images/inmujeres_gray.svg';
import escudo from './../../assets/images/escudo-01.svg';
import {NavLink} from 'react-router-dom';

class Welcome extends Component {
	render() {
		const {data} = this.props.userLogin;
		return (
			<div className="columns is-multiline">
				<div className="column is-10 is-offset-1">
					<div className="level">
						<div className="level-item">
							<img src={logo} alt="INMUJERES" style={{width: 'auto', height: '120px'}}/>
						</div>
						<div className="level-itemgit ">
							<img src={escudo} alt="INMUJERES" style={{width: 'auto', height: '120px'}}/>
						</div>
					</div>
				</div>
				<div className="column is-10 is-offset-1">
					<br/><br/>
					<div className="content">
						<h1>{data.profile.sex === 'M' ? 'Bienvenida' : 'Bienvenido'} {data.profile.title ? `${data.profile.title}. ${data.profile.name}` : data.profile.name},</h1>
						{/*<p>El <strong className="">Instituto Nacional de las Mujeres</strong> y en especial la Dirección de la Política
							Nacional de Igualdad en Entidades Federativas y Municipios responsable de la operación del
							Programa de Fortalecimiento a la Transversalidad de la Perspectiva de Género (PFTPG), pone a
							disposición de las Instancias de las Mujeres en las Entidades Federativas (IMEF), las Instancias
							Municipales de las Mujeres (IMM) y de las unidades administrativas u homólogas a las IMM en las
							alcaldías de la Ciudad de México, la Plataforma e-transversalidad para el registro de la
							información y documentación solicitada en las etapas del proceso y recibir notificaciones
							refrentes al Programa.</p>
						<p>La cobertura del PFTPG es nacional; las 32 entidades federativas, los municipios y las alcaldías
							de la Ciudad de México.</p>
						<p>Las Modalidades de participación son:</p>
						<ol>
							<li>Incorporación de la perspectiva de género en las acciones de la administración pública
								estatal.
							</li>
							<li>Incorporación de la perspectiva de género en las acciones de la administración pública
								municipal y de las alcaldías de la Ciudad de México.
							</li>
							<li>Incorporación de la perspectiva de género en las acciones del gobierno, mediante la
								operación de los Centros para el Desarrollo de las Mujeres en las entidades federativas,
								municipios y las alcaldías de la Ciudad de México.
							</li>
						</ol>
						<p>La invitamos a consultar la sección de "<NavLink to="/ayuda" className="has-text-inm-purple">Ayuda</NavLink>” donde encontrará diferentes documentos normativos,
							de apoyo, así como el calendario con las fechas más relevantes de las etapas operativas del
							Programa.</p>
						*/}	
						<p>El <strong className="">Instituto Nacional de las Mujeres</strong> y la Dirección de la Política 
						Nacional de Igualdad en Entidades Federativas y Municipios, área responsable de la operación del 
						Programa de Fortalecimiento a la Transversalidad de la Perspectiva de Género (PFTPG), le dan la 
						bienvenida a la Plataforma e-transversalidad 3.0, la cual se pone a disposición de las Instancias 
						de las Mujeres en las Entidades Federativas (IMEF), las Instancias Municipales de las Mujeres (IMM) 
						y de las demarcaciones territoriales de la Ciudad de México. 
						</p>

						<p>La Plataforma e-transversalidad 3.0 es la herramienta informática para la captura de la información 
							solicitada en las diferentes etapas operativas del PFTPG; su diseño, estructura, módulos, documentos y 
							los distintos formatos que emite forman parte de las Reglas de Operación para el ejercicio fiscal 2021. 
						</p>

						<p>El PFTPG tiene cobertura nacional; es decir, las 32 entidades federativas, los municipios y las demarcaciones 
							territoriales de la Ciudad de México que así lo deseen podrán participar. Las modalidades de participación son: 
						</p>
						<ol>
							<li>Diseño e implementación de acciones en materia de igualdad entre mujeres y hombres en el ámbito estatal. 
							</li>
							<li>Diseño e implementación de acciones en materia de igualdad entre mujeres y hombres en el ámbito municipal y en las 
								demarcaciones territoriales de la Ciudad de México. 
							</li>
						</ol>

						<p>De acuerdo con el ámbito de sus atribuciones, las IMEF deberán presentar los proyectos en la Modalidad I y las IMM y las unidades administrativas u homólogas a las IMM en las demarcaciones
							 territoriales de la Ciudad de México, en la Modalidad II. 
						</p>

						<p>Le invitamos a consultar la sección "<NavLink to="/ayuda" className="has-text-inm-purple">Ayuda</NavLink>" donde encontrará documentos de apoyo para el diseño 
							y ejecución de los proyectos presentados en el marco del PFTPG. 
						</p>
						<p>
							Con fundamento en los artículos 41 Base III, Apartado C, párrafo segundo, y 134 párrafos primero y séptimo de la Constitución Política de los Estados Unidos Mexicanos; 
							209 numeral 1; 442 numeral 1 inciso f) y 449 de la Ley General de Instituciones y Procedimientos Electorales; 5, y 11 de la Ley General en Materia de Delitos Electorales; 
							y para hacer valer los principios de imparcialidad y neutralidad en los procesos electorales federales, estatales y municipales de este año, hasta el 6 de junio la página de internet, 
							se mantendrá en reserva, salvo las excepciones previstas en el marco normativo.
						</p>
					</div>
				</div>
			</div>
		);
	}
}

export default BaseLayout(Welcome);


// WEBPACK FOOTER //
// ./src/layouts/welcome/index.jsx